module.exports = __webpack_public_path__ + "img/item5-2m.f9d038e4.jpg";